/* unplugin-vue-components disabled */import { render } from "./ContactTip.vue?vue&type=template&id=d48a4076&scoped=true&ts=true"
import script from "./ContactTip.vue?vue&type=script&lang=ts"
export * from "./ContactTip.vue?vue&type=script&lang=ts"

import "./ContactTip.vue?vue&type=style&index=0&id=d48a4076&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48a4076"]])

export default __exports__